export default __webpack_public_path__ + "static/media/Rusty.770163f4.webp";